import { IxTextbox } from './IxTextbox.js';

customElements.define('ix-textbox', IxTextbox);
